import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";
import AceEditor from "react-ace-builds";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-tomorrow";
import "ace-builds/src-noconflict/theme-solarized_dark";
import "ace-builds/src-noconflict/ext-language_tools";

const themes = {
  light: "tomorrow",
  dark: "solarized_dark",
};

const CodeEditor = ({ data, handleChange }) => {
  const theme = useTheme();
  const editorTheme = themes[theme.name];

  const refContainer = useRef("aceEditor");
  const checkValidation = (res) => {
    if (!refContainer?.current?.editor) {
      return;
    }
    if (
      data.mode === "javascript" &&
      res.some((ann) => ann.type === "warning" || ann.type === "error")
    ) {
      return;
    }
    handleChange(data.mode, refContainer.current.editor.getValue());
  };
  return (
    <>
      <AceEditor
        onChange={(content) => handleChange(data.mode, content)}
        mode={data.mode}
        theme={editorTheme}
        name="aceAditor"
        fontSize={14}
        showPrintMargin
        showGutter
        highlightActiveLine
        value={data.codes}
        ref={refContainer}
        onValidate={checkValidation}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: false,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
        }}
        height="100%"
        width="100%"
      />
    </>
  );
};
export default CodeEditor;

CodeEditor.propTypes = {
  data: PropTypes.exact({
    theme: PropTypes.object,
    codes: PropTypes.object,
    mode: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
};
